export const getRangeLimitsFromInstance = (chartInstance, margin, vertical) => {
  let scaling = chartInstance.scaling;
  return {
    max: (vertical ? scaling.verticalAxisMax : scaling.horizontalAxisMax) - margin,
    min: (vertical ? scaling.verticalAxisMin : scaling.horizontalAxisMin) + margin
  };
}

export const getZeroRangeLimits = () => {
  return {
    max: 0, min: 0
  };
}

export const getMinimalRangeLimits = () => {
  return {
    max: Number.MIN_SAFE_INTEGER,
    min: Number.MAX_SAFE_INTEGER
  };
}

export const checkRangeLimits = (rangeLimits, value) => {
  rangeLimits.max = Math.max(rangeLimits.max, value);
  rangeLimits.min = Math.min(rangeLimits.min, value);
}

export const adjustRangeConstraints = (rangeLimits, chartInstance, margin, vertical) => {
  let scaling = chartInstance.scaling;
  const max = rangeLimits.max + margin;
  const min = rangeLimits.min - margin;
  if (vertical) {
    scaling.verticalAxisMax = max;
    scaling.verticalAxisMin = min;
  } else {
    scaling.horizontalAxisMax = max;
    scaling.horizontalAxisMin = min;
  }
  const axisType = chartInstance.getAxisType(!vertical);
  chartInstance.changeScaling((scales) => { 
    (vertical ? scales.yAxes : scales.xAxes)[0][axisType].max = max;
    (vertical ? scales.yAxes : scales.xAxes)[0][axisType].min = min
  });
  let range = vertical ? chartInstance.verticalRange : chartInstance.horizontalRange;
  range.setState({ currentMax: max, max: max, currentMin: min, min: min });
}



// WEBPACK FOOTER //
// ./App/components/modules/measurement-chart-group/getNextDataUtils.js